import React, { useRef, useCallback, useState } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { DeviceLocation } from '#/services/DeviceService';
import { MAP_KEY } from '#/config/constant';

const containerStyle = {
  width: '100%',
  height: '100%',
};

export interface MapProps extends DeviceLocation {
  onChange?: (lat: number, lon: number) => void;
}

function MapView(props: MapProps) {
  const [center, setCenter] = useState({
    lat: props.lat,
    lng: props.lon,
  });
  const mapRef = useRef<google.maps.Map | null>(null);

  const onLoad = useCallback((map: google.maps.Map) => {
    mapRef.current = map;
  }, []);

  const onChangeCenter = () => {
    if (!mapRef.current) {
      return;
    }

    const latlng = mapRef.current.getCenter() as google.maps.LatLng;
    setCenter(latlng.toJSON());

    if (props.onChange) {
      props.onChange(center.lat, center.lng);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return (
    <LoadScript googleMapsApiKey={MAP_KEY} language="ja">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onLoad={onLoad}
        onDragEnd={onChangeCenter}
      >
        <Marker position={center} />
      </GoogleMap>
    </LoadScript>
  );
}

export default React.memo(MapView);
